import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings } from '@styles/index';
import Image from '@base/Image';

const StyledAvatar = styled(Image)`
  border-radius: ${({ $circular }) =>
    $circular ? '50%' : Spacings.SPACING_2B};
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  object-fit: cover;
  cursor: pointer;
  user-drag: none;
  user-select: none;
`;

const NextImageAvatar = (props) => {
  const { src, className, circular, size, alt, ...rest } = props;
  return (
    <StyledAvatar
      {...rest}
      $circular={circular}
      src={src}
      className={className}
      height={size}
      width={size}
      decoding="async"
      loading="eager"
      alt={alt}
    />
  );
};

NextImageAvatar.propTypes = {
  src: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  circular: PropTypes.bool,
  alt: PropTypes.string
};

NextImageAvatar.defaultProps = {
  height: 'initial',
  width: 'initial',
  size: null,
  className: '',
  circular: false,
  alt: 'Avatar'
};

export default NextImageAvatar;
